import request from '@/utils/request'

export function businessState() {
  return request({
    url: '/merchantBusiness/getBusinessState',
    method: 'get',
  })
}
export function updateBusinessState(state) {
  return request({
    url: '/merchantBusiness/updateBusinessState/' + state,
    method: 'post',
  })
}



// WEBPACK FOOTER //
// ./src/api/merchant.js